module.exports = __webpack_public_path__ + "c33ce632e45d6028ef9ffffdca4fe76c.svg";